import styled from 'common/styled-components';
import { HelpOutline } from '@material-ui/icons';
import { Button, IconButton, Tooltip, withStyles } from '@material-ui/core';

export const LabelContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 22px;
  z-index: 10;
  background-color: ${({ theme }) => theme.white.main};
`;

export const InputLabel = styled.label<{ shrink: boolean }>`
  position: absolute;
  transform: translate(0, 24px) scale(1);
  transition: transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  transform-origin: top left;
  color: ${({ theme }) => theme.white.contrastText};
  ${({ shrink }) => shrink && `
    transform: translate(0, 1.5px) scale(0.75);
    transform-origin: top left;
  `}
`;

export const Contianer = styled.div<{ color: string }>`
  position: relative;
  display: block;
  &:focus-within {
    ${InputLabel}{
      transform: translate(0, 1.5px) scale(0.75);
      transform-origin: top left;
      color: ${({ theme }) => theme.primary.main};
    }
  }
`;

export const WandIconContainer = styled(IconButton)`
  position: absolute !important;
  top: 0px;
  right: 16px;
  padding: 2px !important;
  font-size: 1rem !important;
  z-index: 20;
`;

export const AiSuggestionContainer = styled.div`
    background-color: ${({ theme }) => theme.highlighted.aiContainer};
    position: relative;
    display: block;
    margin-top: 10px;
`;

export const WarningMessage = styled.div`
  padding: 5px;
`;

export const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.primary.contrastText,
      maxWidth: '300px',
      fontSize: theme.typography.pxToRem(12),
      border: `1px solid ${theme.palette.common.white}`,
  },
  arrow: {
    color: theme.palette.common.white,
  },
}))(Tooltip);

export const HelpIcon = styled(HelpOutline)`
  color:${({ theme }) => theme.black.dark};
  vertical-align: middle;
  margin-left: 4px;
  margin-top: -35px;
  cursor: pointer;
`;

export const ScrollableDiv = styled.div`
  max-height: 150px
  overflow-y: auto;
  padding: 5px;
`;

export const StyledButton = styled(Button)`
  background: ${({ theme }) => theme.primary.main} !important;
  color: ${({ theme }) => theme.white.light} !important;
  margin: 0 5px 5px !important;
  height: 30px;
  font-size: 12px !important;
`;

export const InfoContainer = styled.div<{ isGridView: boolean }>`
    ${ props => !props.isGridView && `
      position: absolute;
      bottom: 0px;
    `}
    font-size: 0.75rem;
    color: ${props => props.theme.summary.green};
`;